import { Component, OnInit } from '@angular/core';
import { FetchPatientDataAction, PatientDataState, selectPatientDataPatientData } from '../store/index';
import { select, Store } from '@ngrx/store';
import { PatientData } from '@ispm-shared/modules/patient';
import {isEmpty} from "lodash";

@Component({
  selector:    'clinical-data',
  templateUrl: './clinical-data.component.html',
  styleUrls:   ['./clinical-data.component.scss']
})
export class ClinicalDataComponent implements OnInit {
  private mrn = '1';
  private patientData: PatientData;

  constructor(private patientDataStore$: Store<PatientDataState>) { }

  ngOnInit(): void {
    this.patientDataStore$.pipe(select(
      selectPatientDataPatientData
    )).subscribe(patientData => this.patientData = patientData);
    if(!isEmpty(this.mrn)){//the below action dispatch makes a call to server so untill its not empty no need to fire a call
      this.patientDataStore$.dispatch(new FetchPatientDataAction({ mrn: this.mrn}));
    }
  }

}
